<template>
	<div class="c-block-view">
		<!-- right-panel -->
		<div class="left-panel" v-if="ad">
			<Assets :block="ad.block"></Assets>
		</div>

		<!-- left-panel -->
		<div
			:class="['right-panel', { 'no-overflow': tab === 'settings' }]"
			v-if="ad"
		>
			<!-- Body -->
			<div class="right-panel__body">
				<!-- Metadata -->
				<template v-if="tab === 'metadata'">
					<!-- <Section v-if="ad.block.type === 'facebook'" title="Ad start date">
            <ItemDate :block="ad.block"></ItemDate>
          </Section> -->
					<!-- <FormBlockUpdateAdmin v-if="user && user.type === 'ADMIN' && ad.block" :ad="ad.block"></FormBlockUpdateAdmin> -->
					<Labels :block="ad.block"></Labels>

					<EnrichmentDetails
						v-if="tab === 'metadata'"
						:block="ad.block"
						:savedBy="savedBy"
						:savedOn="ad.createdAt"
					></EnrichmentDetails>

					<div
						v-if="adTitle || adCopy || mightHaveTranscript"
						class="c-block-view__divider"
					></div>
					<Section v-if="adTitle" title="Title">
						<p class="article-text-sm">{{ adTitle }}</p>
					</Section>
					<Section v-if="adCopy" title="Body">
						<p class="article-text-sm ad-copy" v-html="adCopy"></p>
					</Section>
					<Section v-if="mightHaveTranscript" title="Transcript">
						<Transcript
							@event="onEvent"
							@seek="seekVideoTo"
							:block="ad.block"
						></Transcript>
					</Section>

					<div class="c-block-view__divider"></div>

					<!-- <FormBlockUpdate v-if="forceRender" :form="ad"></FormBlockUpdate> -->
					<TagSelector
						v-if="forceRender"
						:adId="ad.id"
						@onEdit="onTagEdit"
					></TagSelector>

					<div class="c-block-view__divider"></div>

					<FormBlockDelete
						v-if="forceRender"
						:form="ad"
						@onSubmit="afterDelete"
					></FormBlockDelete>

					<!-- <div class="c-block-view__divider"></div>

          <UtilHistory :block="ad.block"></UtilHistory> -->
				</template>

				<!-- Settings -->
				<template v-if="tab === 'settings'">
					<div
						:class="['c-block-view__form', { disabled: isTrialOver }]"
						v-if="!standalone"
					>
						<!-- <h4>Settings</h4> -->
						<FormBlockUpdate v-if="forceRender" :form="ad"></FormBlockUpdate>
						<div class="c-block-view__divider"></div>
						<FormBlockDelete
							v-if="forceRender"
							:form="ad"
							@onSubmit="afterDelete"
						></FormBlockDelete>
					</div>
				</template>

				<!-- Transcript -->
				<template v-if="tab === 'transcripts'">
					<button class="btn btn-primary">Generate AI Transcripts</button>
				</template>

				<div class="c-block-view__nag" v-if="isTrialOver">
					<a
						href="#"
						@click.prevent="onUpgrade"
						class="btn btn-primary"
						to="/profile"
						>Upgrade to edit</a
					>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Modal from './index.vue';
import Accordion from '@swipekit/components/app/accordion';

import InputBoards from '@swipekit/components/form/input-boards';

import InputTags from '@swipekit/components/form/input-tags';

import FormBlockUpdate from '@swipekit/components/form/form-block-update';
import FormBlockDelete from '@swipekit/components/form/form-block-delete';
import FormBlockUpdateAdmin from '@swipekit/components/form/form-block-update-admin';
import FormGenerateTranscript from '@swipekit/components/form/form-generate-transcript';

import Renderer from '@swipekit/components/renderer';

import Cta from '@swipekit/components/utils/cta';

import ItemDate from '@swipekit/components/item/date';

import Comment from '@swipekit/components/comment';

import Section from './section';

import UtilHistory from '@swipekit/components/utils/history';
import TagSelector from '@swipekit/components/utils/tag-selector';

import Assets from './assets';
import Labels from './labels';
import EnrichmentDetails from './enrichment-details';
import Transcript from './transcript';

import api from '@swipekit/lib/api.js';

export default {
	components: {
		Modal,
		Accordion,
		InputBoards,
		InputTags,
		FormBlockUpdate,
		FormBlockDelete,
		FormBlockUpdateAdmin,
		FormGenerateTranscript,
		Renderer,
		Cta,
		ItemDate,
		Comment,
		Section,
		UtilHistory,
		TagSelector,
		Assets,
		Labels,
		EnrichmentDetails,
		Transcript,
	},

	data: function () {
		return {
			currentBlock: null,
			processing: false,
			forceRender: true,
			tab: 'metadata',
		};
	},

	watch: {
		'options.active': {
			handler: function () {},
		},
		block: function () {
			this.forceRender = false;
			this.$nextTick(() => {
				this.forceRender = true;
			});
		},
	},

	props: {
		latestAd: {},
	},

	computed: {
		mightHaveTranscript: function () {
			let ad = this.ad;

			if (ad.block.transcript && ad.block.transcript.text) {
				return true;
			}

			if (ad.block.assetType === 'video') {
				return true;
			}

			return false;
		},
		ad: function () {
			if (!this.latestAd) {
				return;
			}
			let ad = JSON.parse(JSON.stringify(this.latestAd));

			if (this.currentBlock) {
				ad.block = this.currentBlock;
			}

			return ad;
		},
		transcriptGenerationText: function () {
			return `Generate Transcript?`;
		},
		computedViewerStyle: function () {
			let assetRatio = 1;
			if (this.ad.block && this.ad.block.assetRatio) {
				assetRatio = this.ad.block.assetRatio;
			}

			let padding = assetRatio * 100;
			let str = `padding-bottom:${padding}%;`;

			return str;
		},
		user: function () {
			return this.$store.getters['users/user'];
		},
		commentCount: function () {
			return this.$store.getters['comments/byAd'](this.ad.id).length;
		},
		computedAdBlockType: function () {
			let type = this.ad.block.type;
			type = type.charAt(0).toUpperCase() + type.slice(1);

			return type;
		},
		isTrialOver: function () {
			return this.$store.getters['users/isTrialOver'];
		},
		adCopy: function () {
			let adCopy = this.ad.block.adCopy;

			if (!adCopy) {
				return null;
			}

			if (adCopy.includes('&#') && adCopy.length < 200) {
				return null;
			}

			return adCopy;
		},
		adTitle: function () {
			return this.ad.block.adTitle;
		},
		viewCache: function () {
			return this.$store.getters['ads/viewCache'];
		},
		savedBy: function () {
			if (this.ad.user) return this.ad.user;
			if (!this.ad.userId) return null;
			const workspace = this.$store.getters['workspaces/all'];
			const users = workspace && workspace.users;
			if (!Array.isArray(users)) return null;
			for (let i = 0; i < users.length; i++) {
				if (users[i].id === this.ad.userId) return users[i];
			}
			return null;
		},
		standalone: function () {
			return this.$store.getters['standalone'];
		},
	},

	methods: {
		seekVideoTo: function (milliseconds) {
			const seconds = Number(milliseconds) / 1000;
			if (!Number.isFinite(seconds) || seconds < 0) return;
			const video = this.$el.querySelector('.left-panel video');
			if (!video) return;
			if (video.readyState < 1) {
				video.addEventListener(
					'loadedmetadata',
					function () {
						video.currentTime = seconds;
					},
					{ once: true }
				);
				video.load();
			} else {
				video.currentTime = seconds;
			}
			video.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
		},
		onTagEdit: function () {},
		onGeneratedTranscript: function (block) {
			this.currentBlock = block;
		},
		onEvent: function (payload) {
			payload.blockId = this.ad.block.id;

			api.api.track(payload);
		},
		onSubmit: function () {
			this.$emit('onSubmit');
		},
		async afterDelete() {
			this.$emit('afterDelete');
		},
		onUpgrade: function () {
			this.$router.push('/profile');
			this.$store.dispatch('ads/setView', null);
		},
	},

	mounted: function () {
		//this.options.active = true;
	},
};
</script>

<style lang="scss">
.c-block-view {
	width: 100%;
	height: 100%;
	display: flex;

	.left-panel {
		position: relative;
		width: 50%;
		height: 100%;
		flex-grow: 1;
		border-top-left-radius: 10px;
		border-bottom-left-radius: 10px;
		overflow: hidden;
		overflow-y: auto;
		scrollbar-width: none;

		background-color: var(--color-bg-2);

		&__viewer {
			display: flex;
			justify-content: center;
			align-items: stretch;

			overflow: hidden;
			overflow-y: auto;

			position: relative;
			//padding: var(--spacer);
			//overflow: scroll;
			text-align: center;
		}

		> .btn {
			position: absolute;
			bottom: var(--spacer-sm);
			right: var(--spacer-sm);
		}

		.media-wrapper {
			max-height: 100%;
			display: inline-block;
			box-shadow: var(--box-shadow-light);

			//overflow-y: auto;

			img {
				display: block;
				max-width: 100%;
			}
		}

		.c-renderer {
			width: 100%;
			height: 100%;

			> div {
				height: 100%;
			}
		}

		.r-facebook .VueCarousel .VueCarousel-navigation button {
			width: var(--spacer);
			height: var(--spacer);
			background-color: var(--color-bg-4);
			border-radius: var(--border-radius-full);
		}

		.c-renderer {
			video {
				width: 100%;
				height: 100%;
				object-fit: contain;
			}
		}
	}

	.right-panel {
		display: flex;
		flex-direction: column;
		width: 50%;
		height: 100%;
		border-left: hsl(var(--s), 20%, 80%) solid 1px;
		overflow-y: auto;
		border-top-right-radius: 10px;
		border-bottom-right-radius: 10px;
		scrollbar-width: none;

		background-color: var(--color-bg-1);

		.c-input-tags {
			.vue-tags-input .ti-tag {
				padding: var(--margin-sm) var(--margin-lg);
				padding-right: var(--margin-lg);
			}
			.vue-tags-input .ti-input {
				min-height: auto;
			}

			.vue-tags-input .ti-tags .ti-new-tag-input-wrapper input {
				border-radius: 4px;
			}
		}

		.c-input-boards-dropdown {
			&__input {
				min-height: 44px;
			}
		}

		&.no-overflow {
			overflow-y: initial;
		}

		.c-item-date {
			padding-top: 0;
		}

		.c-comment {
			margin-left: calc(-1 * var(--margin-lg));
			width: calc(100% + var(--margin-lg) * 2);
		}

		.ad-copy {
			white-space: break-spaces;
		}

		.c-form {
			margin: var(--margin-lg) 0;
		}

		.c-accordion {
			img {
				max-width: 100% !important;
			}
		}

		&__body {
			padding: var(--spacer-sm);

			> article {
				margin: var(--margin-lg) 0;
				white-space: pre-wrap;
			}

			.article-text-sm {
				margin-bottom: 0;
			}

			code {
				font-size: var(--font-size-xs);
			}

			h6 {
				margin-top: var(--margin-lg);
			}
		}

		.c-cta {
		}

		&__buttons {
			margin-top: auto;
			width: 100%;
			border-top: var(--color-bg-5) solid 1px;

			.btn {
				position: relative;
				max-height: initial;
				padding: var(--spacer-sm);
				width: 50%;
				border-radius: 0;

				&:hover,
				&:active,
				&:focus {
					z-index: 1;
				}

				&:first-child {
					border-right: var(--color-bg-5) solid 1px !important;
				}
			}
		}
	}

	&__footer {
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 64px;
		border-top: var(--color-bg-5) solid 1px;
		background-color: var(--color-bg-2);
		border-bottom-left-radius: 10px;
		border-bottom-right-radius: 10px;

		padding: 16px;
		display: flex;
		justify-content: space-between;
	}

	&__divider {
		width: 100%;
		height: 1px;
		background-color: var(--color-bg-5);
		margin: var(--spacer-sm) 0;
	}

	&__form {
		&.disabled {
			cursor: not-allowed;
			opacity: 0.8;
			pointer-events: none;
		}
	}

	&__nag {
		border: hsla(var(--s), 60%, 60%, 0.15) solid 1px;
		border-radius: var(--border-radius);
		padding: var(--spacer-sm);
		background-color: hsla(var(--s), 60%, 60%, 0.15);
	}

	@media screen and (max-width: 600px) {
		display: block;
		overflow-y: auto;

		.left-panel {
			width: 100%;
			height: auto;
		}
		.right-panel {
			width: 100%;
			height: auto;
		}

		&__footer {
			display: none;
		}
	}
}
</style>
